
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import FilterContainer from "../../../molecules/organization/FilterContainer.vue";
import { ReportFilterStore } from "../../../stores/reports/ReportFilterStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import InlineFormTreeselect from "../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import FormInput from "../../../../../landing/src/molecules/form/FormInput.vue";
import NoRecords from "../../../../../common/src/components/NoRecords.vue";
import ServiceFilter from "../filters/ServiceFilter.vue";
import ProductFilter from "../filters/ProductFilter.vue";
import OperatingRegimeFilter from "../filters/OperatingRegimeFilter.vue";
import ApplicationFilter from "../filters/ApplicationFilter.vue";
import CustomFilter from "../filters/reports/CustomFilter.vue";
import FilterHeader from "../filters/FilterHeader.vue";
import { ReportListStore } from "../../../stores/reports/ReportListStore";
import { ApplicationTypeStore } from "../../../../../common/src/stores/ApplicationTypeStore";
import { ProductTypeStore } from "../../../../../common/src/stores/ProductTypeStore";
import { ServiceTypeStore } from "../../../../../common/src/stores/ServiceTypeStore";
import { OperatingRegimeTypeStore } from "../../../../../common/src/stores/OperatingRegimeTypeStore";
import { handleError } from "../../../../../common/src/utility/errorUtils";

@Component({
    components: {
        FilterHeader,
        ServiceFilter,
        ProductFilter,
        OperatingRegimeFilter,
        ApplicationFilter,
        CustomFilter,
        FilterContainer,
        LoadingOverlay,
        InlineFormTreeselect,
        FormInput,
        NoRecords,
    },
})
export default class ReportsSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    readonly reportsFilterStore: ReportFilterStore = this.container.get(ReportFilterStore);
    readonly applicationFilterStore: ApplicationTypeStore = this.container.get(
        "ReportApplicationTypeStore",
    );
    readonly serviceFilterStore: ServiceTypeStore = this.container.get("ReportServiceTypeStore");
    readonly productFilterStore: ProductTypeStore = this.container.get("ReportProductTypeStore");
    readonly operatingRegimeFilterStore: OperatingRegimeTypeStore = this.container.get(
        "ReportOperatingRegimeTypeStore",
    );
    readonly listStore: ReportListStore = this.container.get(ReportListStore);

    created() {
        this.applicationFilterStore.load().catch(handleError);
        this.serviceFilterStore.load().catch(handleError);
        this.productFilterStore.load().catch(handleError);
        this.operatingRegimeFilterStore.load().catch(handleError);
    }

    get tags() {
        const items = (this.listStore.items || [])
            .map((reportItem) => reportItem.tags?.flat())
            .flat();
        const itemSet = new Set(items);
        return Array.from(itemSet);
    }
}
